import { render, staticRenderFns } from "./viewTenant.vue?vue&type=template&id=4b46d766&scoped=true"
import script from "./viewTenant.vue?vue&type=script&lang=js"
export * from "./viewTenant.vue?vue&type=script&lang=js"
import style0 from "./viewTenant.vue?vue&type=style&index=0&id=4b46d766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b46d766",
  null
  
)

export default component.exports